module.exports = __webpack_public_path__ + "static/media/32a7c006-7784-489c-94c6-9add34326a23.27b47f79.jpg";